
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { themeV5 } from 'theme/v5'

const AssignedViewDetails = ({ items }) => {
  return (
    <Stack data-id="fleet-contract-modal-tab">
      <Stack
        borderRadius='5px'
        border='1px solid'
        borderColor={themeV5.palette.accent.sky}
        p='10px'
        flexDirection='row'
        flexWrap='wrap'
        gap={2}>
        {items?.map((item, index) => (
          <Stack
            key={`contract-details-${index}`}
            flex={1}
            minWidth='calc(100%/3)'>
            <Typography variant="bodyLarge" color={themeV5.palette.accent.sky}>
              {item?.label}
            </Typography>
            <Typography variant="bodyLarge" sx={{ wordBreak: 'break-word', paddingRight: '15px' }}>
              {item?.value}
            </Typography>
          </Stack>
        ))}

      </Stack>
    </Stack>
  )
}

export default AssignedViewDetails
